var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"https://proresult.no/kontakt/"}},[_vm._t("default",[_vm._v("Kontakt oss")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }